import { GetCampaignParams, useReturnOnAdSpend } from '@features/campaigns';
import {
  useReport,
  CpgReportsParams,
  useCurrentAdSpend,
  UseReportsProps,
  useCampaign,
} from '@features/campaigns/subdomains/cpg';
import { CpgLciReportsFieldsData } from '../utils/build-presentation';

type FetchParams = {
  reportParams: Omit<CpgReportsParams, 'campaignId'>;
  campaignParams: GetCampaignParams;
};

type CpgLciReportFieldsReturn = {
  loading: boolean;
  data?: CpgLciReportsFieldsData;
  error?: string;
};

export const useCpgLciReportFields = (
  fetchParams: FetchParams
): CpgLciReportFieldsReturn => {
  const { campaign, isFetching: loadingCampaign } = useCampaign(
    fetchParams.campaignParams
  );

  const reportsProps: UseReportsProps = {
    campaignId: campaign?.id,
    reportParams: fetchParams.reportParams,
  };
  const { report, loading: loadingReport } = useReport(reportsProps);

  const loading = loadingCampaign || loadingReport;

  const adSpendHook = useCurrentAdSpend();

  const { value: iroas } = useReturnOnAdSpend({
    campaign: campaign ?? { startDate: '', endDate: '', id: 0 },
    reportDate: report?.reportDate ?? null,
    sales: report?.projectedIncrementalSales ?? null,
    adSpend: adSpendHook.adSpend,
  });

  const { value: roas } = useReturnOnAdSpend({
    campaign: campaign ?? { startDate: '', endDate: '', id: 0 },
    reportDate: report?.reportDate ?? null,
    sales: report?.totalProjectedSales ?? null,
    adSpend: adSpendHook.adSpend,
  });

  const roasData: CpgLciReportsFieldsData['roasData'] = {
    iroas,
    roas,
  };

  if (!campaign || !report) {
    return { error: 'Missing required data for PPT generation', loading };
  }

  return {
    loading,
    data: {
      brandLogo: null,
      campaign,
      selectedReportDate: report.reportDate,
      report,
      roasData,
    },
  };
};
